<template>
  <div v-if="!!block.data.embed" class="entry-gallery embed-wrapper w-mb2">
    <div ref="player" :data-plyr-provider="block.data.service" :data-plyr-embed-id="block.data.embed"></div>
    <!-- <div class="embed-container">
      <iframe style="width: 100%" frameborder="0" allowfullscreen="" :src="block.data.embed"></iframe>
    </div> -->
  </div>
</template>
<script>
import Plyr from "plyr";

export default {
  name: "EmbedBlock",
  props: ["block"],
  mounted() {
    new Plyr(this.$refs.player, {
      youtube: {
        noCookie: true,
        rel: 0,
        iv_load_policy: 3,
        controls: 0,
      },
    });
  },
};
</script>
<style lang="scss" scoped>
// :deep() {
//   @import "plyr";
// }

.embed-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  height: 0;
  padding-top: 56.25%;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
